
const isDebug = false


export { isDebug }
